<template>
    <!-- border radius button -->
    <button class="big-button" :style="cssProps" :disabled="props.disabled" @click="emit('clickButton')">
        {{ props.text }}
    </button>
</template>

<script setup lang="ts">
import { computed } from 'vue';
// import type { PropType } from 'vue';

const emit = defineEmits(['clickButton']);

const props = defineProps({
    // 버튼 텍스트
    text: {
        type: String,
        default: '버튼',
    },
    // 버튼 색상
    bgColor: {
        type: String,
        default: 'blue',
    },
    textColor: {
        type: String,
        default: '#fff',
    },
    fontSize: {
        type: String,
        default: '1rem',
    },
    padding: {
        type: String,
        default: '1rem',
    },
    shadow: {
        type: String,
        default: '',
    },
    borderRadius: {
        type: String,
        default: '0',
    },
    line: {
        type: String,
        default: 'none',
    },
    // 버튼 클릭 이벤트
    // onClick: {
    //     type: Function as PropType<(event: MouseEvent) => void>, // 정확한 타입 지정
    //     default: () => { },
    // },
    disabled: {
        type: Boolean,
        default: false,
    },
    disabledBgColor: {
        type: String,
        default: '#DCDFE3',
    },
});

const cssProps = computed(() => ({
    color: props.textColor,
    fontSize: props.fontSize,
    padding: props.padding,
    boxShadow: props.disabled ? 'none' : props.shadow,
    borderRadius: props.borderRadius,
    border: props.line,
    background: props.disabled ? props.disabledBgColor : props.bgColor,
    cursor: props.disabled ? 'not-allowed' : 'pointer',
}));
</script>

<style scoped>
button {
    width: 100%;
    font-weight: bold;
    transition:
        opacity 0.3s ease,
        transform 0.1s ease;

    &:disabled {
        transition:
            all 0.3s ease,
            transform 0.1s ease;
    }

    &:hover {
        opacity: 0.7;
    }

    &:active {
        transform: scale(0.99);
        opacity: 0.7;
    }
}
</style>
